import {
  PROD_HOMEPAGE_HOSTNAME,
  STAGING_HOMEPAGE_HOSTNAME,
} from '@diamond/shared/environments';
import type { RegistrationCorrectionStep } from '@diamond/shared/features/registration/browser';

export function getPublicHomepageOrigin(): string {
  const fromEnv =
    process.env['NX_HOMEPAGE_BASE_URL'] ||
    process.env['NEXT_PUBLIC_HOMEPAGE_BASE_URL'] ||
    process.env['SOL_HOMEPAGE_BASE_URL'];

  if (fromEnv) {
    return fromEnv.replace(/\/$/, '');
  }

  if ((process.env['NX_API_URL'] ?? '').includes('staging')) {
    return `https://${STAGING_HOMEPAGE_HOSTNAME}`;
  }

  return `https://${PROD_HOMEPAGE_HOSTNAME}`;
}

export interface BuildHomepageNooCorrectionUrlOptions {
  step: RegistrationCorrectionStep;
  registrationToken: string;
  outletIndex?: number;
}

export function buildHomepageNooCorrectionUrl({
  step,
  registrationToken,
  outletIndex,
}: BuildHomepageNooCorrectionUrlOptions): string {
  const url = new URL(`${getPublicHomepageOrigin()}/noo-registration`);
  url.searchParams.set('step', step);
  url.searchParams.set('registration_token', registrationToken);
  url.searchParams.set('correction', '1');

  if (typeof outletIndex === 'number') {
    url.searchParams.set('outlet_index', String(outletIndex));
  }

  return url.toString();
}

export type HomepageNooRegistrationResumeStep =
  | 'login'
  | 'otp'
  | 'document-incomplete';

export interface BuildHomepageNooRegistrationResumeUrlOptions {
  step: HomepageNooRegistrationResumeStep;
  registrationToken?: string;
}

export function buildHomepageNooRegistrationResumeUrl({
  step,
  registrationToken,
}: BuildHomepageNooRegistrationResumeUrlOptions): string {
  const url = new URL(`${getPublicHomepageOrigin()}/noo-registration`);
  url.searchParams.set('step', step);
  url.searchParams.set('flow', 'noo-registration');

  if (registrationToken?.trim()) {
    url.searchParams.set('registration_token', registrationToken.trim());
  }

  return url.toString();
}

